<nav class="bottom-nav">
	<div class="nav-item" [class.active]="isActive('/app/dashboard/profilo')" (click)="navigate('/app/dashboard/profilo')">
		<i [class]="isActive('/app/dashboard/profilo') ? 'bi bi-person-fill' : 'bi bi-person'" style="line-height: 1;"></i>
		<span>Profilo</span>
	</div>
	<div class="nav-item" [class.active]="isActive('/app/dashboard')" (click)="navigate('/app/dashboard')">
		<i [class]="isActive('/app/dashboard') ? 'bi bi-pen-fill' : 'bi bi-pen'" style="line-height: 1;"></i>
		<span>Firma</span>
	</div>
	<div class="nav-item" [class.active]="isActive('/app/dashboard/profilo/storico-pratiche')" (click)="navigate('/app/dashboard/profilo/storico-pratiche')">
		<i [class]="isActive('/app/dashboard/profilo/storico-pratiche') ? 'bi bi-folder-fill' : 'bi bi-folder2-open'" style="line-height: 1;"></i>
		<span>Storico</span>
	</div>
	<div class="nav-item" (click)="confirmLogout()">
		<img src="assets/images/icons/logout.svg" alt="Logout" />
		<span>Logout</span>
	</div>
</nav>
